import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API } from '@app/shared/api/api.service';
import * as login from '../state';
import { Observable } from 'rxjs';
import { BackupCode, Identity } from '@app/auth/models';
import { TwoFACode } from '@app/auth/core/state/auth.model';

@Injectable()
export class LoginService {
  constructor(private http: HttpClient, private api: API) {}

  public login$({ email, password }: login.Credentials): Observable<Identity> {
    const auth = window.btoa(`${email}:${password}`);
    const headers = new HttpHeaders().set('Authorization', `Basic ${auth}`);

    return this.http.get<Identity>(this.api.LOGIN(), {
      headers,
    });
  }

  public verify2FACode$(twoFACode: TwoFACode): Observable<Identity> {
    return this.http.post<Identity>(this.api.VERIFY_2FA_CODE(), {
      code: parseInt(twoFACode.code, 10),
    });
  }

  public verify2FAViaRecoveryCode$(recoveryBackupCode: BackupCode): Observable<Identity> {
    return this.http.post<Identity>(this.api.VERIFY_RECOVERY_2FA(), recoveryBackupCode);
  }
}
